import { useDispatch, useSelector } from 'react-redux'

import { SubscriptionDetail } from '../model/subscriptionDetail.model'
import { FetchSubscriptionDetailProps } from '../services/subscriptionDetail.service'
import { fetchSubscriptionDetail } from '../store/subscriptionDetail.reducer'
import {
  selectSubscriptionDetail,
  selectSubscriptionDetailLoading,
  selectSubscriptionDetailError,
} from '../store/subscriptionDetail.selectors'

import { StoreError } from '~/common/model'

interface useSubscriptionDetail {
  getSubscriptionDetail: (fetchSubscriptionDetailProps: FetchSubscriptionDetailProps) => unknown
  subscriptionDetail?: SubscriptionDetail
  loading: boolean
  error?: StoreError
}

export default function useSubscriptionDetail(subscriptionId: string): useSubscriptionDetail {
  const dispatch = useDispatch()

  return {
    getSubscriptionDetail: (fetchSubscriptionDetailProps: FetchSubscriptionDetailProps) =>
      dispatch(fetchSubscriptionDetail(fetchSubscriptionDetailProps)),
    subscriptionDetail: useSelector(selectSubscriptionDetail(subscriptionId)),
    loading: useSelector(selectSubscriptionDetailLoading(subscriptionId)),
    error: useSelector(selectSubscriptionDetailError(subscriptionId)),
  }
}
